export default __webpack_public_path__ + "static/media/fontawesome-webfont.b09f4960.woff";